import store from '@/store'

export default () => {
  const getBreadCrumbs = () => store.getters['global/getBreadCrumbs']

  return {
    getBreadCrumbs,
  }
}
